module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/btn_order_catalog-ea795e7230fb75d9641dffdfbd50b47e.png";